import {
  BILLING_TAB_CONFIG,
  BILLING_TABS,
} from "../../config/billing-tab-routes";

export const ADMIN_BILLING_TAB_CONFIG = BILLING_TAB_CONFIG.filter(
  (tab) => tab.id !== BILLING_TABS.HISTORY,
);
